import React from "react";

export const Toolbar = ({
    children,
    className = '',
}) => {
    return (
        <table
            className={"toolbar-buttons " + className}
        >
            <tbody>
                <tr className="toolbar-row">
                    <td>
                        {children != null &&
                            children
                        }
                    </td>
                </tr>
            </tbody>
        </table>
    );
}


export const ToolbarButton = ({
    onClick,
    icon,
    text = '',
    className = '',
    color = 'rgb(0, 156, 204)',
    disabled = false,
}) => {

    const handleClick = () => {
        if (onClick != null && !disabled) {
            onClick();
        }
    }

    return (
        <div
            className={"tollbar-button " + className}
            onClick={handleClick}
            data-disabled={disabled}
            data-visible={true}
        >
            <div
                className="tollbar-button-icon"
                style={{ color: color }}
            >
                {icon != null &&
                    icon
                }
            </div>
            <div className="tollbar-button-desc">
                <span> {text}</span>
            </div>
        </div>
    );
}